module.exports = __webpack_public_path__ + "img/image6.520bcab9.png";